import React from "react";

const LoginFormFields = ({ form, isCreating, onChange }) => (
  <>
    <input
      name="email"
      type="email"
      placeholder="Email"
      value={form.email}
      onChange={onChange}
      required
    />
    <input
      name="password"
      type="password"
      placeholder="Password"
      value={form.password}
      onChange={onChange}
      required
    />
    {isCreating && (
      <>
        <input
          name="firstName"
          type="text"
          placeholder="First Name"
          value={form.firstName}
          onChange={onChange}
          required
        />
        <input
          name="lastName"
          type="text"
          placeholder="Last Name"
          value={form.lastName}
          onChange={onChange}
          required
        />
        <input
          name="organizationCode"
          type="text"
          placeholder="Organization Code"
          value={form.organizationCode}
          onChange={onChange}
          required
        />
      </>
    )}
  </>
);

export default LoginFormFields;
